export default async function getClientIP(): Promise<string> {
  try {
    const response = await fetch('https://api.kijk.nl/ipdata');
    const data = await response.json();
    return data.clientIP || '';
  } catch (error) {
    return '';
  }
}
